module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "article-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.date)
    }
  }), _vm._v(" "), _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.description)
    }
  }), _vm._v(" "), _c('hr')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a8ebbc4!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/ArticleView.vue
// module id = 32
// module chunks = 1